import { cn } from '@rematter/ui-web/lib';

import { CategoryRecord } from '../../../types/inventoryItem';

import { CategoryFormFields } from './CategoryFormFields';

type Props = {
  category?: CategoryRecord | null;
  disabled?: boolean;
  className?: string;
};

export const CategoryDetailsForm = ({
  category,
  disabled = false,
  className,
}: Props) => (
  <div className={cn('@CategoryDetailsForm', className)}>
    <CategoryFormFields
      disabled={disabled}
      showTimestamps
      category={category}
    />
  </div>
);
